module.exports = __webpack_public_path__ + "static/media/success.1c417b59.svg";